import { ceil, floor, round } from 'lodash/fp';

const getApproximateByNumber = approximate => num => x => (approximate(x / num) * num);

const ceilByNumber = getApproximateByNumber(ceil);

const floorByNumber = getApproximateByNumber(floor);

const roundByNumber = getApproximateByNumber(round);

export const ceilByTen = ceilByNumber(10);

export const floorByTen = floorByNumber(10);

export const roundByTwo = roundByNumber(2);

export const roundByHalf = roundByNumber(1 / 2);

export const roundByQuarter = roundByNumber(1 / 4);
